import {
  criarCatalogosIndexedDb,
  type CatalogosPersistidos,
} from '@next/compartilhados/catalogos'
import {
  criarClienteHttpCondominio,
  type ClienteHttp,
} from '@next/infraestrutura/http'

import type { DependenciasSrcNext } from '../dependencias-src-next'

export type InfraestruturaAplicacao = Readonly<{
  httpCondominio: ClienteHttp
  catalogosPersistidos: CatalogosPersistidos
}>

export const criarInfraestrutura = (
  dependencias: DependenciasSrcNext,
): InfraestruturaAplicacao => ({
  httpCondominio: criarClienteHttpCondominio(
    dependencias.servicosHttp.condominio,
  ),
  catalogosPersistidos: criarCatalogosIndexedDb(),
})
